// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_MigrarLaudosInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de POST /migration/laudos/migrar-todas
 * (controllers/migration/laudos.php::migrar_todas).
 *
 * Um unico campo, OBRIGATORIO: a franquia cujos laudos vao migrar. A varredura
 * das fotos e GLOBAL no export (o form nao tem franquia) e o loader resolve o
 * pertencimento pelo item da E6 — mas a CARGA continua por franquia, como as
 * irmas.
 */
import { registerContract } from './validate'

export interface Migration_MigrarLaudosInput {
zoho_id_unidade?: string
data_ini?: string
data_fim?: string
ids?: string
}

registerContract('Migration_MigrarLaudosInput', {
  zoho_id_unidade: { type: 'string',  required: false },
  data_ini:        { type: 'string',  required: false },
  data_fim:        { type: 'string',  required: false },
  ids:             { type: 'string',  required: false },
})
